import api from "./api";

export const createUpdatePersonalInfo = async (payload: FormData) => {
  return (
    await api.post(
      "/StudentInfo/StudentInfo/CreateUpdatePersonalInfo",
      payload,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    )
  )?.data as Response;
};

export const createUpdateJambResult = async (payload: FormData) => {
  return (
    await api.post(
      "/StudentInfo/StudentInfo/CreateUpdateJambResult",
      payload,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    )
  )?.data as Response;
};

const JHU = "JHU";

export const getCountries = async () => {
  return (
    await api.get(`/Utilities/Utilities/GetAllCountries?school=${JHU}`)
  )?.data as CountryResponse;
};

export const getStateByCountryId = async (id: number) => {
  return (
    await api.get(
      `/Utilities/Utilities/GetStateByCountryId?id=${id}&school=${JHU}`
    )
  )?.data as StateResponse;
};

export const getAllMaritalStatus = async () => {
  return (await api.get("/Utilities/Utilities/GetAllMaritalStatus"))
    ?.data as MaritalStatusResponse;
};

export const createUpdateInstitution = async (payload: FormData) => {
  return (
    await api.post(
      "/StudentInfo/StudentInfo/CreateUpdateInstitution",
      payload,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    )
  )?.data as Response;
};

export const getInstitutionByApplicantId = async (id: string) => {
  return (
    await api.get(
      `/StudentInfo/StudentInfo/GetInstitutionByApplicantId?Id=${id}`,
    )
  )?.data as InstitutionResponse;
};

export const getInstitutionByShortName = async (shortName: string) => {
  return (await api.get(`/Institutions/GetInstitutionByShortName/${shortName}`))
    ?.data as SchoolResponse;
};

export const getWorkHistoryByApplicantId = async (id: string) => {
  return (
    await api.get(
      `/StudentInfo/StudentInfo/GetWorkHistoryByApplicantId?Id=${id}`,
    )
  )?.data as WorkHistoryResponse;
};

export const createUpdateWorkHistory = async (payload: FormData) => {
  return (
    await api.post(
      "/StudentInfo/StudentInfo/CreateUpdateWorkHistory",
      payload,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    )
  )?.data as Response;
};

export const getInstitutionById = async (id: number) => {
  return (await api.get(`/StudentInfo/StudentInfo/GetInstitutionById?Id=${id}`))
    ?.data as InstitutionByIdResponse;
};

export const getWorkHistoryById = async (id: number) => {
  return (await api.get(`/StudentInfo/StudentInfo/GetWorkHistoryById?Id=${id}`))
    ?.data as WorkHistoryByIdResponse;
};

export const deleteWorkHistory = async (id: number) => {
  return (
    await api.delete(`/StudentInfo/StudentInfo/DeleteWorkHistory?Id=${id}`)
  )?.data as Response;
};

export const deleteInstitution = async (id: number) => {
  return (
    await api.delete(`/StudentInfo/StudentInfo/DeleteInstitution?Id=${id}`)
  )?.data as Response;
};

export const createReference = async (payload: {
  titleId: number;
  applicantId: string;
  refereeName: string;
  refereeEmail: string;
  refereeCategory: number;
}) => {
  return (
    await api.post("/StudentInfo/StudentInfo/CreateReference", payload, {
      headers: { "Content-Type": "application/json" },
    })
  )?.data as Response;
};

export const getReferenceByApplicantId = async (id: string) => {
  return (
    await api.get(`/StudentInfo/StudentInfo/GetAllReferences?ApplicantId=${id}`)
  )?.data as ReferenceResponse;
};

export const deleteReference = async (id: number) => {
  return (
    await api.delete(`/StudentInfo/StudentInfo/DeleteReference?Id=${id}`)
  )?.data as Response;
};

export const getQualificationByApplicantId = async (id: string) => {
  return (
    await api.get(
      `/StudentInfo/StudentInfo/GetQualificationByApplicantId?Id=${id}`,
    )
  )?.data as QualificationResponse;
};

export const getAllDisability = async () => {
  return (await api.get(`/Utilities/Utilities/GetAllDisability`))
    ?.data as DisabilityResponse;
};

export const getAllReligion = async () => {
  return (await api.get("/Utilities/Utilities/GetAllReligion"))
    ?.data as ReligionResponse;
};

export const getDashboardStatus = async (id: string) => {
  return (await api.get(`/StudentInfo/StudentInfo/Dashboard?Id=${id}`))
    ?.data as DashboardStatusResponse;
};

export const createUpdateUploadNysc = async (payload: FormData) => {
  return (
    await api.post("/StudentInfo/StudentInfo/CreateUpdateUploadNysc", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  )?.data as Response;
};

export const getUploadNyscByApplicantId = async (id: string) => {
  return (
    await api.get(
      `/StudentInfo/StudentInfo/GetUploadNyscByApplicantId?Id=${id}`,
    )
  )?.data as NyscUploadResponse;
};

export const getLgaByStateId = async (id: number) => {
  return (
    await api.get(
      `/Utilities/Utilities/GetLgaByStateId?id=${id}&school=${JHU}`
    )
  )?.data as LGAResponse;
};

export const getPersonalInfoByApplicantId = async (id: string) => {
  return (
    await api.get(
      `/StudentInfo/StudentInfo/GetPersonalInfoByApplicantId?Id=${id}`,
    )
  )?.data as PersonalInfoResponse;
};

export const getJambByApplicantId = async (id: string) => {
  return (
    await api.get(`/StudentInfo/StudentInfo/GetJambByApplicantId?Id=${id}`)
  )?.data as JambResultResponse;
};

export const processPayment = async (payload: ProcessPaymentPayload) => {
  return (await api.post("/Payment/processPayment", payload))?.data;
};

export const queryProcessedPayment = async (id: string) => {
  return (await api.get(`/Payment/QueryProcessedPayment?ref=${id}`))?.data;
};
export const queryProcessedPaymentWithChannel = async (payload: {
  reference: string;
  channel: string;
}) => {
  return (
    await api.get(
      `/Payment/${payload.reference}/QueryPayment?paymentChannel=${payload.channel}`,
    )
  )?.data;
};

export const getAllGender = async () => {
  return (await api.get("/Utilities/Utilities/GetAllGenders"))
    ?.data as GenderResponse;
};

export const getPaymentHistoryByApplicantId = async (id: string) => {
  return (await api.get(`/Payment/PaymentHistoryByApplicantId?Id=${id}`))?.data;
};

export const getAllProgramTypes = async () => {
  return (await api.get("/Academics/GetAllProgramTypesAsync"))
    ?.data as programTypeResponse;
};

export const getAllTitle = async () => {
  return (await api.get("/Utilities/Utilities/GetAllTitle"))
    ?.data as TitleResponse;
};

export const getGrades = async () => {
  return (await api.get("/Utilities/Utilities/GetAllGrade"))
    ?.data as GradeResponse;
};

export const getSubjects = async () => {
  return (await api.get("/Utilities/Utilities/GetAllSubj"))
    ?.data as SubjectResponse;
};

export const CreateUpdateSubject = async (payload: SubjectPayload) => {
  return (await api.post("/Utilities/Utilities/CreateUpdateSubject", payload))
    ?.data;
};

export const getSubjectsByApplicantId = async (id: string) => {
  return (
    await api.get(`/Utilities/Utilities/GetSubjectByApplicantId?id=${id}`)
  )?.data as SubjectByApplicantResponse;
};

export const deleteSubjectByApplicantId = async (
  payload: DeleteSubjectPayload,
) => {
  return (
    await api.delete(
      `/Utilities/Utilities/DeleteSubjectbyApplicantId?applicantId=${payload.applicantId}&Id=${payload.id}`,
    )
  )?.data;
};

export const getAllDisplayTab = async (params: DisplayTabPayload) => {
  return (
    await api.get(
      `/Utilities/Utilities/GetAllTabDisplaybysessionId?id=${params.sessionId}&batchName=${params.batchName}&programType=${params.programType}`,
    )
  )?.data as DisplayTabResponse;
};

export const getCouponDiscount = async (payload: CouponDiscountPayload) => {
  return (
    await api.get(
      `/Payment/getProcessPayment?CouponCode=${payload.couponCode}&ApplicantId=${payload.applicantId}`,
    )
  )?.data as APIResponse<CouponDiscount>;
};

export const deleteNyscUpload = async (id: number) => {
  return (
    await api.delete(`/StudentInfo/StudentInfo/DeleteUploadNysc?Id=${id}`)
  )?.data as Response;
};

export const acceptAdmissionOffer = async (payload: AcceptOfferPayload) => {
  return (
    await api.post(
      `/StudentInfo/StudentInfo/AcceptOrRejection?applicantId=${payload.applicantId}&decision=${payload.decision}&rejectionReason=${payload.rejectionReason ?? ""}`,
    )
  )?.data as APIResponse<any>;
};

export const getPaymentChannels = async () => {
  return (await api.get("/Payment/GetPaymentChannel?isActive=true"))
    ?.data as APIResponse<PaymentChannel[]>;
};

export const processPaymentWithChannel = async (
  payload: PaymentPayloadWithChannel,
) => {
  const payloadToSend = {
    amount: payload.amount,
    returnUrl: payload.returnUrl,
    applicantId: payload.applicantId,
    couponCode: payload.couponCode,
    paymentType: payload.paymentType,
  };
  return (
    await api.post(
      `/Payment/ProcessPaymentbyChannel?paymentChannel=${payload.channel}`,
      payloadToSend,
    )
  )?.data as APIResponse<PaymentResponse>;
};
